export const TextError = {
  empty: 'Ce champ ne peut être vide',
  hexaColor: 'La couleur saisie n’est pas au format hexadecimal',
  email: 'L’email n’est pas valide',
  phone: "Le numéro de téléphone saisi n'est pas au bon format",
  lastName: 'Le nom ne peut être vide',
  positive: 'Le champ doit être positif',
  textarea: 'Nombre de charactère limité à 500',
}
